
import React from "react";
import { useParams, Link } from "react-router-dom";
import { products } from "./VisionSystem";
import "./VisionSystemDetails.css";

export default function VisionSystemDetails() {
  const { id } = useParams();
  const product = products.find((p) => p.id === parseInt(id));

  if (!product) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h2>Product Not Found</h2>
        <Link to="/VisionSystem">Go Back</Link>
      </div>
    );
  }

  
  return (
    <div className="product-details">
      <img src={product.img} alt={product.title} className="product-image" />
      <div className="product-info">
        <h1>{product.title}</h1>
        <p>{product.desc}</p>
        <Link to="/" className="back-btn">
          ← Back to Products
        </Link>
      </div>
    </div>
  );
}
